import React, { useState, useEffect } from 'react';
import { MapPin, Calendar } from 'lucide-react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { serviceData } from '../mockData';
import Footer from '../components/Footer';
import RequirementForm from '../components/RequirementForm';

const ServicesPage = () => {
  const [showAll, setShowAll] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedService, setSelectedService] = useState("");
  const { id } = useParams();
  const location = useLocation();

  const sortedService = [...serviceData];
  const serviceWithImages = sortedService.filter((p) => p.image);
  const serviceWithoutImages = sortedService.filter((p) => !p.image);
  const styles = `.section-title {
  text-align: center;
}
.section-title h2 {
  font-size: 3rem;
  font-weight: 700;
}
.heading-underline {
  width: 80px;
  height: 6px;
  margin: 0 auto 1.2rem auto;
  background: #2992cc;
  border-radius: 4px;
}
.heading-tagline {
  color: #7a7a7a;
  font-size: 1.5rem;
  font-weight: 400;
  margin-top: .5rem;
  margin-bottom: 1.5rem;
  letter-spacing: 0;
  line-height: 1.3;
}
.gap {
  margin-bottom: 2.5rem;
}
`;
  const visibleService = showAll
    ? serviceWithImages
    : serviceWithImages.slice(0, 11);

 useEffect(() => {
    setTimeout(() => {
      const element = document.getElementById(`service-${id}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 300);
  }, [id]);


  return (
    <div className="min-h-screen">
      <style>{styles}</style>
      <section
        className="relative flex items-center justify-center text-white overflow-hidden"
        style={{
          backgroundImage: "url(/images/architects-collaborating-blueprints-construction-site.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 bg-black/70"></div>

        <div className="relative z-10 max-w-7xl px-4 sm:px-8 md:px-16 lg:px-20 text-center py-24 md:py-32 lg:py-40">
          <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold leading-tight mb-6">
            <span className="bg-white bg-clip-text text-transparent drop-shadow-lg">
              Our Services
            </span>
          </h1>
          <p className="text-lg sm:text-xl text-gray-100 max-w-3xl mx-auto leading-relaxed">
            We deliver innovative, safe, and cost effective structural engineering solutions
            for residential, commercial, and high rise services.
          </p>

        </div>
      </section>

      {/* 🔹 services with Images */}
      <section className="w-full">
        <div className="gap"></div>

        {visibleService.map((service, idx) => (
          <div
            id={`service-${service.id}`}
            key={service.id}
            className={`w-full flex flex-col md:flex-row ${idx % 2 === 1 ? 'md:flex-row-reverse' : ''
              } min-h-[380px]`}
            style={{
              background:
                idx % 2 === 0
                  ? 'linear-gradient(90deg, #f7faff 60%, #f4f9fd 100%)'
                  : 'linear-gradient(90deg, #FFF 60%, #e7f3fb 100%)',
            }}
          >
            {/* Image Side */}
            {service.image && (
              <div className="md:w-1/2 w-full">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full object-fill md:object-fill"
                  style={{ height: '512px', display: 'block' }}
                />
              </div>
            )}

            {/* Content Side */}
            <div className="md:w-1/2 w-full flex flex-col justify-center p-10">
              <h3 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-2 tracking-tight text-center" style={{ fontFamily: "Merriweather, serif" }}>
                {service.title}
              </h3>
              <span className="block w-24 sm:w-32 md:w-40 h-0.5 sm:h-1  lg:mx-auto bg-gradient-to-r from-yellow-500 via-yellow-300 to-white rounded-full mt-4 sm:mt-6 mb-4"></span>
              {/* <div className="w-20 h-1 bg-gradient-to-r from-[#011321] to-[#03365f] rounded mb-6"></div> */}

              {/* <div className="flex flex-wrap items-center gap-4 mb-6">
                {service.location && (
                  <a
                    className="flex items-center px-4 py-2 rounded-full bg-blue-100 text-blue-700 font-medium text-base no-underline hover:text-[#11b0e7]"
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                      service.location
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <MapPin className="w-4 h-4 mr-2" />
                    {service.location}
                  </a>
                )}
                {service.completionDate && (
                  <span className="flex items-center px-4 py-2 rounded-full bg-gray-200 text-gray-700 font-medium text-base">
                    <Calendar className="w-4 h-4 mr-2" />
                    {new Date(service.completionDate).getFullYear()}
                  </span>
                )}
                {service.status && (
                  <span className="flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-[#211e88] to-[#11b0e7] text-white font-medium text-base">
                    {service.status}
                  </span>
                )}
              </div> */}

              <div className="max-w-2xl mx-auto mb-10">
                <p className="text-[14px] md:text-lg text-gray-700 mb-6 text-justify">
                  {service.description}
                </p>

                {service.points && (
                  <ul className="list-disc list-inside text-left text-gray-800 space-y-2">
                    {service.points.map((item, index) => (
                      <li key={index} className="text-sm md:text-base">
                        {item}
                      </li>
                    ))}
                  </ul>
                )}
              </div>


              <div className="flex flex-col sm:flex-row sm:gap-4 gap-2 mx-auto">
                <button
                  onClick={() => {
                    setSelectedService(service.title);
                    setOpen(true);
                  }}
                  className="
    inline-flex items-center justify-center
    px-5 py-2 sm:px-6 sm:py-2.5
    bg-gradient-to-r from-[#011321] to-[#03365f]
    text-white text-sm sm:text-base font-semibold
    rounded-full shadow-lg
    hover:scale-105 duration-200 transition-all
    w-full sm:w-auto max-w-[260px]
  "
                >
                  Share Your Requirement <span className="ml-2">→</span>
                </button>



                {/* {service.brochureURL && (
                  <a
                    href={service.brochureURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-6 py-2 bg-gradient-to-r from-[#011321] to-[#03365f] text-white text-[15px] md:text-lg font-semibold rounded-full border border-[#011321] hover:bg-gray-200 transition-all duration-300 w-[200px] sm:w-auto"
                  >
                    Download E-brochure
                  </a>
                )} */}
              </div>
            </div>
          </div>
        ))}

        {/* View More / Show Less Button */}
        {/* {servicesWithImages.length > 6 && (
          <div className="text-center mt-10 px-6 py-8">
            <button
              onClick={() => setShowAll(!showAll)}
              className="px-6 py-3 bg-black text-white font-semibold rounded-full hover:scale-105 transition-all duration-300"
            >
              {showAll ? 'Show Less' : 'View More'}
            </button>
          </div>
        )} */}
      </section>

      {/* 🔹 Show "Other services" only after View More */}
      {/* {showAll && servicesWithoutImages.length > 0 && (
        <section className="max-w-5xl mx-auto my-16 px-6">
          <h3 className="text-3xl font-bold mb-6 text-center">
            Other services
          </h3>
          <ul className="space-y-4">
            {servicesWithoutImages.map((service) => (
              <li
                key={service.id}
                className="flex flex-col md:flex-row md:items-center md:justify-between border-b border-gray-300 pb-3"
              >
               
                <span className="
        text-lg font-semibold text-gray-800
        w-full md:w-1/2 
        text-left 
        pl-4 md:pl-8 lg:pl-12 xl:pl-16
      ">
                  {service.title}
                </span>

               
                {service.location && (
                  <span className="
          text-gray-600 flex items-center gap-2
          w-full md:w-1/2 
          text-left
          pl-4 md:pl-10 lg:pl-20 xl:pl-40 2xl:pl-60
        ">
                    <MapPin className="w-4 h-4 text-gray-500" />
                    {service.location}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </section>
      )} */}

      <Footer />
      {open && (
        <RequirementForm
          service={selectedService}
          onClose={() => {
            setOpen(false);
            setSelectedService("");
          }}
        />
      )}

    </div>
  );
};

export default ServicesPage;
